import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../../Assets/CSS/Styles.scss";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    
      axios.get('http://localhost:8000/api/blogs/type/blogs')


      .then((res) => {
        setBlogs(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="text-center py-10">Loading blogs...</p>;
  }

  if (!blogs.length) {
    return <p className="text-center py-10">No blogs available.</p>;
  }

  const featuredBlog = blogs.find((blog) => blog.type === "featured") || blogs[0];
  const regularBlogs = blogs.filter((blog) => blog._id !== featuredBlog._id);

  return (
    <div className="container mx-auto px-6 py-12 max-w-7xl mt60">
      {/* Category and Section Title */}
      <div className="mb-12">
        <p className="text-[18px] mb-2 color: #374151 font-ui">Category</p>
        <h1 className="text-5xl md:text-6xl font-heading text-[#FBBF24]">Blogs</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        {/* Main Content Area */}
        <div className="lg:col-span-2">
          {/* Featured Insight */}
          {featuredBlog && (
            <div className="mb-12">
              <h3 className="font-heading mb-6 text-[25px] font-bold">Featured Insight</h3>
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <img
                  src={`http://localhost:8000/uploads/${featuredBlog.image}`}
                  alt={featuredBlog.title}
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h2 className="font-heading mb-4 text-[25px] font-bold">{featuredBlog.title}</h2>
                  <p className="text-[15px] mb-4">{featuredBlog.overview}</p>
                  <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4">
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      {featuredBlog.author}
                    </span>
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M7 16h.01M12 16h.01M15 16h.01M18 6H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2z" />
                      </svg>
                      {new Date(featuredBlog.publishDate).toLocaleDateString()}
                    </span>
                  </div>
                  <Link
                    to={`/blog/${featuredBlog._id}`}
                    className="text-[#5B42F3] font-semibold flex items-center gap-1 hover:underline"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                        d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          )}

          {/* All Blogs */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {regularBlogs.map((blog) => (
              <div key={blog._id} className="bg-white rounded-lg shadow-md overflow-hidden">
                <img
                  src={`http://localhost:8000/uploads/${blog.image}`}
                  alt={blog.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="font-heading mb-2 text-[25px] font-bold">{blog.title}</h3>
                  <p className="text-[15px] mb-4">{blog.overview}</p>
                  <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4">
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      {blog.author}
                    </span>
                    <span className="flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M7 16h.01M12 16h.01M15 16h.01M18 6H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2z" />
                      </svg>
                      {new Date(blog.publishDate).toLocaleDateString()}
                    </span>
                  </div>
                  <Link
                    to={`/blog/${blog._id}`}
                    className="text-[#5B42F3] font-semibold flex items-center gap-1 hover:underline"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                        d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="bg-white p-6 rounded-lg shadow-md mb-8">
            <h3 className="font-heading mb-4 text-[25px] font-bold">Categories</h3>
            <ul className="space-y-2 font-ui">
              <li className="hover:text-[#5B42F3]">Digital Transformation</li>
              <li className="hover:text-[#5B42F3]">Case Studies</li>
              <li className="hover:text-[#5B42F3]">College & School Automation</li>
              <li className="hover:text-[#5B42F3]">ERP Solutions</li>
            </ul>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="font-heading mb-4 text-[25px] font-bold">Recent Blogs</h3>
            <ul className="space-y-3 font-ui">
              {blogs.slice(0, 4).map((blog) => (
                <li key={blog._id}>
                  <Link to={`/blog/${blog._id}`} className="hover:text-[#5B42F3]">
                    {blog.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* CTA */}
      <section className="bg-blue-900 text-white py-16 mt-12">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h2 className="font-heading font-bold mb-4 text-[30px]">
            Enjoyed the blog? Let's build something great together.
          </h2>
          <p className="text-[18px] font-ui mb-8">
            Ready to transform your institution with cutting-edge ERP solutions?
          </p>
          <Link to="/freedemo" className="inline-block">
            <button className="bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2">
              Book Free Demo
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Blogs;
